import Sort from './sort'
class SizeColor {
    constructor() {
        this.selectors = {
            document: document,           
            color: '.js-info-color',
            colors: '.js-info-colors',
            sizes: '.js-info-sizes',           
            productFeatures: '.js-product-features',
            addToCart: '#js-btn-cart',
            productId: '#product-id',           
            price: '#priceval',
            priceOld: '#priceval_old',
            productImage: '#js-product-image',
            statusProd: '.js-product-status',
            tasteSelect : 'select[name=size_id]',
            tasteColor: 'input[name=color_id]',
            oneClickBtn: '.js-one-click',
            creditBtn: '.js-credit-popup',
            sizeOptions: '.size-value',
            code: '.js-product-cod',
            slickImages: '.js-product-slider-horizontally-4product, .js-product-slider-nav-vertical-4product, .js-product-slider-nav-horizontally-4product'
        };
        this.init();
        this.events();
    };
    init() {       
        this.Sort = new Sort()
        this.getNodes();
    }
    
    getNodes() {
        var _this = this;
        this.nodes = {};
        $.each(this.selectors, function(key, selector) {
            _this.nodes[key] = $(selector);
        });
    }

    events() {
        self = this;
        
		if ($('.js-size-select').length > 0){
            function formatRepo (item) {
                if (item.loading) return item;
                // console.log(item.text)                                         
                let itemParse = JSON.parse(item.text),
                    $element = $(`<span class="select2-result-repository">${itemParse.text}</span>`);                       
                return $element
            }
            function formatState (item) {                        
                if (!item.id == '') {                   
                    let itemParse = JSON.parse(item.text),
                        $element = $(`<span>${itemParse.text}</span>`);
                    return $element
                } else {   
                    let $element = $(`<span>${item.text}</span>`);
                    return $element
                }               
            }           

            for (let option of Array.from(self.nodes.sizeOptions)) {
                if ($(option).data('stock') == 'False') {                   
                    $(option).attr('disabled', true);
                }
            }

	        $('.js-size-select').select2({
                width: '200px',
	            placeholder: $('.size_text_default').data('select'),
                allowClear: true,                               
                templateResult: formatRepo,
                templateSelection: formatState
	        });
        }


        function disableButtons () {
            self.nodes.oneClickBtn.length ? self.nodes.oneClickBtn.removeAttr('id') : '';
            self.nodes.creditBtn.length ? 
                self.nodes.creditBtn.addClass('disabled') && 
                self.nodes.creditBtn.removeAttr('id')
                : '';
        }

        self.nodes.colors.length || self.nodes.sizes.length ? disableButtons() : '';

        function changeOldPrice(product, $this) {
            const currency = self.nodes.price.next().data('currency');
            self.nodes.priceOld.text(`${product['price_old']}`);           
            self.nodes.priceOld.next().text(currency);
            $this.closest('.js-content').find(".closure-price-old span:not(.currency)").text(`${product['price_old']}`);
            $this.closest('.js-content').find(".closure-price-old .currency").text(currency);
        }
        function clearOldPrice($this){
            self.nodes.priceOld.text('');
            self.nodes.priceOld.next().text('');            
            $this.closest('.js-content').find(".closure-price-old span").text('');
        }

        function changeItemDates($this, unit) {           
            self.nodes.price.text(`${unit['price']}`);            
            $this.closest('.js-content').find(".closure-price span:not(.currency)").text(`${unit['price']}`);
            unit['price'] < unit['price_old'] ? changeOldPrice(unit, $this) : clearOldPrice($this);
            self.nodes.productId.text( unit['features']['art'] );
            self.nodes.addToCart.attr('data-href',`/cart/add?product_id=${ unit['id'] }`);
            self.nodes.addToCart.attr('data-product', unit['id']);
            self.nodes.addToCart.attr('data-id', unit['id']);
            // iterate product image sliders
            self.nodes.slickImages.each((i, item_image) => {
                // destroy current sliders
                $(item_image).find('.slick-slide').each((i, slick_image) => {
                    $(slick_image).remove()
                })
                let imgList = '';
                unit['images'].forEach((image, i) => {
                    let active = '',
                        current = '',
                        imgDiv = '',
                        imgDivHref = 'https://i.simpalsmedia.com/marketplace/products/original/';
                    i == 0 ? (active = 'active', current = 'current') : '';
                    $(item_image).hasClass('product_view_wrap_slider') ?
                        imgDiv = `<div class="product_view_wrap_slider_item ${active}" data-img-name="${i}">
                                        <a class="js-product-image ${current} product_view_wrap_slider_item_link"
                                        href="${imgDivHref}${image}" rel="slider">
                                            <img src="${imgDivHref}${image}" id="js-product-image" class="product_view_wrap_slider_item_link_image">
                                        </a>
                                    </div>` :
                        imgDiv = `<div class="product_view_wrap_thumbnails_item">
                                    <div class="product_view_wrap_thumbnails_item_img">
                                        <img src="${imgDivHref}${image}">
                                    </div>
                                </div>`;
                    imgList += imgDiv;
                })
                if (unit['images'].length <= 1 && $(item_image).hasClass('product_view_wrap_thumbnails')){                   
                    $(item_image).css('display', 'none')
                } else{
                    $(item_image).css('display', 'block')
                    $(item_image).slick('slickAdd', imgList);
                    $(item_image)[0].slick.refresh()
                }
            });
        }      

        if ($('#js-features').length && $('.js-info-colors').length) {
            self.nodes.tasteSelect.on('change', e => {
                const $this = $(e.currentTarget),
                    valSize = $this.val(),
                    availableColors = $('.js-info-color');
                
                $('.select2-selection__rendered').removeAttr('title');
                    // console.log(CONFIG)
                for (let color of Array.from(availableColors)) {
                    $(color).attr('disabled', true);
                    $(color).parent().removeClass('resize');
                    $(color).parent().css('border', '#DCDCDC solid 1px');
                }
                $('input[name=color_id]').prop('checked', false);
                self.nodes.addToCart.addClass('disabled');
                CONFIG['root']['products'].forEach(item => {
                    if (item['features']['size'] == valSize) {                   
                        $('.js-info-sizes').data('product_size', item['features']['size']);                   
                        for (let color of Array.from(availableColors)) {								
                            if ($(color).val() == item['features']['color']) {               			
                                $(color).attr('disabled', false);
                            }
                        }               
                    }
                })            
            });

            self.nodes.document.on('change', self.selectors.color, e => {
                const $this = $(e.currentTarget),
                    valColor = $this.val(),
                    parent = $this.parent(),
                    source = 'https://i.simpalsmedia.com/marketplace/products/original/';              
                parent.siblings().removeClass('resize')
                parent.siblings().css('border', '#DCDCDC solid 1px')
                parent.addClass('resize');
                parent.css('border', `${$this.data('color')} solid 1px`);
                self.nodes.addToCart.removeClass('disabled'); 
                $('.select2-selection__rendered').removeAttr('title');          
                CONFIG['root']['products'].forEach(item => {
                    if (item['features']['color'] == valColor && item['features']['size'] ==  $('.js-info-sizes').data('product_size')){                                            
                        // console.log(item);                                        
                        changeItemDates($this, item);
                        self.nodes.productImage.attr('src', `${source}${item['images'][0]}`)
                        self.nodes.productImage.parent().attr('href', `${source}${item['images'][0]}`)
                        switch(item['is_available']) {
                            case 'in-stock': 
                                self.nodes.statusProd.html(`<span class="product_info_nav_item_text">${self.nodes.sizes.data('in_stock')}</span>
                                <i class="icon-custom icon1-ok"></i>`)
                                self.nodes.addToCart.find('.btn_flex').find('span').text(`${self.nodes.sizes.data('to-cart')}`);                            
                                !self.nodes.colors.length ? self.nodes.addToCart.removeClass('disabled') : '';
                                self.nodes.oneClickBtn.length ? 
                                    self.nodes.oneClickBtn.attr('id', 'js-btn-one-click') &&
                                    self.nodes.oneClickBtn.removeClass('disabled')
                                    : '';
                                self.nodes.creditBtn.length ? 
                                    self.nodes.creditBtn.removeClass('disabled') &&
                                    self.nodes.creditBtn.magnificPopup({})
                                    : '';
                            break
                            case 'not-in-stock':
                                self.nodes.statusProd.html(`<span class="product_info_nav_item_text no-stock">${self.nodes.sizes.data('no_stock')}</span>`);
                                self.nodes.addToCart.find('.btn_flex').find('span').text(`${self.nodes.sizes.data('not_in-cart')}`)
                            break  	
                            case 'by-order':
                                self.nodes.statusProd.html(`<span class="product_info_nav_item_text no-stock">${self.nodes.sizes.data('by_order')}</span>`);
                                self.nodes.addToCart.find('.btn_flex').find('span').text(`${self.nodes.sizes.data('not_in-cart')}`)
                            break
                        }                   
                    }
                });			
            });
        }
        if(!$('.js-info-colors').length) {
            self.nodes.tasteSelect.on('change', e => {
                const $this = $(e.currentTarget),                
                    valSize = $this.val();

                $('.select2-selection__rendered').removeAttr('title');
    
                self.nodes.creditBtn.addClass('disabled')
                self.nodes.addToCart.addClass('disabled');         
                CONFIG['root']['products'].forEach(item => {
                    if (item['features']['size'] == valSize) {   
                        changeItemDates($this, item);
                        switch(item['is_available']) {
                            case 'in-stock': 
                                self.nodes.statusProd.html(`<span class="product_info_nav_item_text">${self.nodes.sizes.data('in_stock')}</span>
                                <i class="icon-custom icon1-ok"></i>`)
                                self.nodes.addToCart.find('.btn_flex').find('span').text(`${self.nodes.sizes.data('to-cart')}`);     
                                self.nodes.addToCart.removeClass('disabled');
                                self.nodes.oneClickBtn.length ? 
                                    self.nodes.oneClickBtn.attr('id', 'js-btn-one-click') &&
                                    self.nodes.oneClickBtn.removeClass('disabled')
                                    : '';
                                self.nodes.creditBtn.length ? 
                                    self.nodes.creditBtn.removeClass('disabled') &&
                                    self.nodes.creditBtn.magnificPopup({})
                                    : '';                 
                            break
                            case 'not-in-stock':
                                self.nodes.statusProd.html(`<span class="product_info_nav_item_text no-stock">${self.nodes.sizes.data('no_stock')}</span>`);
                                self.nodes.addToCart.find('.btn_flex').find('span').text(`${self.nodes.sizes.data('not_in-cart')}`)
                            break  	
                            case 'by-order':
                                self.nodes.statusProd.html(`<span class="product_info_nav_item_text no-stock">${self.nodes.sizes.data('by_order')}</span>`);
                                self.nodes.addToCart.find('.btn_flex').find('span').text(`${self.nodes.sizes.data('not_in-cart')}`)
                            break
                        }              
                    }
                });   
            }); 
        }
    }
}
new SizeColor()
